import React from 'react';
import CommentSection from './Category/CommentSection';

const Support = () => {
  return (
    <div>
     <div className='__container'>
         <CommentSection/>
     </div>
    </div>
  );
}

export default Support;
